import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Podcasts from '@/components/screens/podcasts/Podcasts';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME, PRERENDER_PAGES } from '@/helpers/variables';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { IPodcastPage } from '@/interfaces/podcastsPage.interface';

import { getPagesNumbersPaths } from '@/helpers/helpers';

interface IPodcastsPagesVisitedDynamicProps {
  books: IPodcastPage;
}

const PodcastsPagesVisitedDynamic: NextPage<IPodcastsPagesVisitedDynamicProps> = ({ books }) => {
  useRedirectToFirstPage('/podcasts/sorting/visited');
  return <Podcasts books={books} sortingName="по просмотрам" sortingUrl={'sorting/visited'} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;
  const [booksRes] = await Promise.all([fetch(`${API_URL}satellite/podcast/podcast?page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}`)]);
  const [books] = await Promise.all([booksRes.json()]);

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default PodcastsPagesVisitedDynamic;
